var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconArrowTransferVertical = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9291 1.57129C16.4814 1.57129 16.9291 2.019 16.9291 2.57129V19.0146L19.1499 16.7933C19.5403 16.4027 20.1735 16.4026 20.5641 16.7931C20.9547 17.1836 20.9547 17.8167 20.5643 18.2073L16.6363 22.1363C16.4487 22.3239 16.1944 22.4293 15.9291 22.4293C15.6639 22.4293 15.4095 22.3239 15.222 22.1364L11.293 18.2074C10.9024 17.8169 10.9024 17.1837 11.293 16.7932C11.6835 16.4027 12.3166 16.4027 12.7072 16.7932L14.9291 19.0151V2.57129C14.9291 2.019 15.3768 1.57129 15.9291 1.57129ZM7.36396 1.86518C7.75445 1.47469 8.38754 1.47465 8.77808 1.86509L12.7071 5.79309C13.0977 6.18357 13.0977 6.81673 12.7073 7.20731C12.3168 7.59788 11.6836 7.59796 11.293 7.20749L9.07107 4.98607V21.4293C9.07107 21.9816 8.62335 22.4293 8.07107 22.4293C7.51878 22.4293 7.07107 21.9816 7.07107 21.4293V4.9865L4.85017 7.2074C4.45965 7.59792 3.82648 7.59792 3.43596 7.2074C3.04544 6.81687 3.04544 6.18371 3.43596 5.79318L7.36396 1.86518Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconArrowTransferVertical);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconArrowTransferVertical.85cca3a52500f03b3f1e0db6b63f935d.svg";